import "./sentry";
import { initAnalytics } from "./analytics";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider, darkTheme } from "@rainbow-me/rainbowkit";
import { ErrorBoundary } from "@sentry/react";
import "@rainbow-me/rainbowkit/styles.css";
import "./index.css";
import { wagmiConfig } from "./wagmi.ts";
import { App } from "./App.tsx";

initAnalytics();

const queryClient = new QueryClient();

const SentryBoundary = ErrorBoundary as unknown as React.ComponentType<{
  fallback: React.ReactNode;
  children: React.ReactNode;
}>;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SentryBoundary fallback={<p>Something went wrong.</p>}>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider theme={darkTheme({ accentColor: "#7c3aed" })}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </SentryBoundary>
  </StrictMode>,
);
